/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_No_MetadataInputs */

const en_read_along_no_metadata = /** @type {(inputs: Read_Along_No_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No metadata`)
};

const es_read_along_no_metadata = /** @type {(inputs: Read_Along_No_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay metadatos`)
};

/**
* | output |
* | --- |
* | "No metadata" |
*
* @param {Read_Along_No_MetadataInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_no_metadata = /** @type {((inputs?: Read_Along_No_MetadataInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_No_MetadataInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_no_metadata(inputs)
	return en_read_along_no_metadata(inputs)
});